/* eslint-disable indent */
import { useContext, useMemo } from 'react';

import { Product } from '@src/constants';
import { Store } from '@src/store';

export const useGetProductCode = () => {
  const {
    state: {
      stateUser: { selectedProduct },
      stateFormIFLFlat: { selectedIProduct: flatIsuranceProduct },
      stateFormIFLHouse: { selectedIProduct: houseInsuranceProduct },
      stateFormNSSport: { insuranceProduct: sportInsuranceProduct },
      stateFormPets: { selectedIProduct: petsInsuranceProduct },
      statePetsTelevetPlus: { selectedIProduct: televetPlusInsuranceProduct },
      stateMite: { insuranceProductPolicy: miteInsuranceProduct },
      stateFormNS: { insuranceProduct: nsInsuranceProduct },
    },
  } = useContext(Store);

  return useMemo(() => {
    switch (selectedProduct) {
      case Product.HOUSE:
        return houseInsuranceProduct?.code;
      case Product.APARTMENT:
        return flatIsuranceProduct?.code;
      case Product.SPORT:
        return sportInsuranceProduct?.code;
      case Product.PETS:
        return petsInsuranceProduct?.code;
      case Product.MITE:
        return miteInsuranceProduct?.productCode;
      case Product.NS:
        return nsInsuranceProduct?.code;
      case Product.PETS_TELEVET_PLUS:
        return televetPlusInsuranceProduct?.code;
      default:
        return undefined;
    }
  }, [selectedProduct]);
};
